{
    "NAME": "Types d'appareilsLangue",
    "DeviceTypesLanguage_Unknown": "Inconnu",
    "DeviceTypesLanguage_Trunk": "Tronc",
    "DeviceTypesLanguage_TrunkGateway": "Passerelle principale",
    "DeviceTypesLanguage_ChatService": "Service de chat",
    "DeviceTypesLanguage_EmailServer": "Serveur de messagerie",
    "DeviceTypesLanguage_ExtensionOrEndpoint": "Extension \/ Point de terminaison",
    "DeviceTypesLanguage_ExtensionOrEndpointTrunking": "Extension (Tronçonneuse)",
    "DeviceTypesLanguage_ExtensionOrEndpointHospitality": "Extension (Hôtellerie)",
    "DeviceTypesLanguage_GroupSuper": "Supergroupe",
    "DeviceTypesLanguage_GroupCollective": "Groupe (Collectif)",
    "DeviceTypesLanguage_GroupLinear": "Groupe (linéaire)",
    "DeviceTypesLanguage_GroupCyclic": "Groupe (cyclique)",
    "DeviceTypesLanguage_GroupAcd": "Groupe (ACD)",
    "DeviceTypesLanguage_GroupTrunk": "Groupe (Coffre)",
    "DeviceTypesLanguage_GroupVoicemail": "Groupe (Messagerie vocale)",
    "DeviceTypesLanguage_GroupPage": "Groupe (Page)",
    "DeviceTypesLanguage_GroupDepartment": "Département",
    "DeviceTypesLanguage_GroupSecurityGroup": "Groupe de sécurité",
    "DeviceTypesLanguage_GroupSecurityGroupBroadworks": "Groupes de prestataires de services",
    "DeviceTypesLanguage_GroupAcdMsTeams": "Files d'attente d'appels",
    "DeviceTypesLanguage_Park": "Parc",
    "DeviceTypesLanguage_VoicemailApplication": "Application de messagerie vocale",
    "DeviceTypesLanguage_VoicemailAnnouncementHuntGroup": "Annonce de file d'attente (Groupe Hunt)",
    "DeviceTypesLanguage_VoicemailAnnouncementGeneral": "Annonce de file d'attente (Général)",
    "DeviceTypesLanguage_AutoAttendant": "Répondant automatique",
    "DeviceTypesLanguage_MusicOnHold": "Musique en attente",
    "DeviceTypesLanguage_Conference": "Conférence",
    "DeviceTypesLanguage_PilotNumber": "Pilote \/ Alternative",
    "DeviceTypesLanguage_DnisEntry": "Entrée DNIS"
}